import React, { Component } from "react";
import { Spinner} from 'reactstrap';
import Graficos from './Graficos';
import { AppContext } from './../AppContext';
import url from './variables/url.js';
const local = url.localBack;
const fechaInicio = url.fechaInicio;
const fechaFin = url.fechaInicio;

class PadreGraficos extends Component {
  constructor(props) {
    super(props);
    let currentUser = this.context;
    this.state = {        
         loading: true,
         iduser: 0,
         roles: [],
         validados: 0,
         noValidados: 0,
         delegados: 0,
         sinDelegar: 0,
         pendientes: 0,
         atendidos: 0,
         parcAtendidos: 0,
         pendientesCoor: 0,
         atendidosCoor: 0,
         parcAtendidosCoor: 0,
      };
  }

  componentDidMount() {    
    let currentUser = this.context    
      if (currentUser != null) {
         this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });          
          if (currentUser.roles.includes('SUBDECANO')) {
              this.populate();
          } else {
              this.isForbidden();
          }
             
      }
    
   }

    isForbidden() {
        this.props.history.push({
            pathname: '/',            
        })
    }    

   componentDidUpdate(){
       let currentUser = this.context
       if (currentUser != null && ((this.state.validados + this.state.noValidados) == 0) && this.state.iduser == 0) {
      /*console.log("updateded");*/
       this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
       /*console.log(currentUser.roles);*/
           if (currentUser.roles.includes('SUBDECANO')) {
               this.populate();
           } else {
               this.isForbidden();
           }
     }
   }

  populate(){
    /*console.log("Populate")*/
    fetch(local + 'Graficos/GetData', {
      method: 'GET'
    })
      .then(response => response.json())
      .then(data => {
        //console.log(data);
        this.setState({ validados: data.validados, noValidados: data.noValidados, 
            delegados: data.delegados, sinDelegar: data.sinDelegar, 
            pendientes: data.pendientes, atendidos: data.atendidos, parcAtendidos: data.parcAtendidos,
            pendientesCoor: data.pendientesCoor, atendidosCoor: data.atendidosCoor, 
            parcAtendidosCoor: data.parcAtendidosCoor, loading: false})
      })
      .catch(function F(error) {
        console.log(error);
      })
  }

  renderGraficos(validados, noValidados, delegados, sinDelegar, 
                 pendientes, atendidos, parcAtendidos, 
                 pendientesCoor, atendidosCoor, parcAtendidosCoor){
      return (<Graficos 
               series1={[noValidados, validados]} 
               series2={[sinDelegar, delegados]} 
               series3={[atendidos, parcAtendidos, pendientes]} 
               series4={[atendidosCoor, parcAtendidosCoor, pendientesCoor]}/>);
  }

  render() {   
     const currentUser = this.context;
      
    if(currentUser == null){
      return <><Spinner animation="grow" /></>;
    }
   
    let content = this.state.loading ? <><Spinner animation="grow" /></> 
    : this.renderGraficos(this.state.validados, 
                          this.state.noValidados,
                          this.state.delegados,
                          this.state.sinDelegar,
                          this.state.pendientes,
                          this.state.atendidos,
                          this.state.parcAtendidos,
                          this.state.pendientesCoor,
                          this.state.atendidosCoor,
                          this.state.parcAtendidosCoor
                          );

    return (      
        <div>
            {content}
        </div>     
    );
  }
}
PadreGraficos.contextType = AppContext;
export default PadreGraficos;